/* globals BaseUneet, isTouch */
/* eslint-disable class-methods-use-this */
class Uneet extends BaseUneet {
  constructor(e) {
    super(e)
    this.__processTooltips()
  }

  __processTooltips() {
    const elems = this._e.querySelectorAll('[u-tooltip]')
    // go through all the tooltipped elements
    Array.from(elems).forEach((elem) => {
      // if it is not active...
      if (!elem.hasClass('tooltip-active')) {
        // make it active
        elem.addClass('tooltip-active')
        // create the DOM
        const tooltipElem = document.createElement('span')
        tooltipElem.addClass('m_tooltip')
        tooltipElem.innerHTML = elem.getAttribute('u-tooltip')
        // append the DOM
        elem.appendChild(tooltipElem)
        /* eslint-disable func-names */
        const showTooltip = function (el) {
          el.addClass('isShowingTooltip')
        }
        const hideTooltip = function (el) {
          el.removeClass('isShowingTooltip')
        }
        const showTooltipThenHide = function (ev) {
          let el = ev.currentTarget
          if (el === null) {
            el = ev.target
          }
          showTooltip(el)
          setTimeout((elm) => {
            hideTooltip(elm)
          }, 4000, el)
        }
        /* eslint-enable func-names */
        if (isTouch()) {
          elem.addEventListener('touchend', showTooltipThenHide, false)
        }
        elem.addEventListener('mouseover', (ev) => { showTooltip(ev.currentTarget) }, false)
        elem.addEventListener('mouseout', (ev) => { hideTooltip(ev.currentTarget) }, false)
      }
    })
  }

  __storeCookie(cname, obj, duration = 100000) {
    // http://clubmate.fi/setting-and-reading-cookies-with-javascript/
    ((name, value, days) => {
      let expires
      if (days) {
        const date = new Date()
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
        expires = `; expires=${date.toGMTString()}`
      } else {
        expires = ''
      }
      document.cookie = `${name}=${value}${expires}; path=/`
    })(cname, window.btoa(JSON.stringify(obj)), duration)
  }

  __retrieveCookie(cname) {
    const cookie = ((name) => {
      const nameEQ = `${name}=`
      const ca = document.cookie.split(';')
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i]
        while (c.charAt(0) === ' ') {
          c = c.substring(1, c.length)
        }
        if (c.indexOf(nameEQ) === 0) {
          return c.substring(nameEQ.length, c.length)
        }
      }
      return null
    })(cname)
    if (cookie) {
      return JSON.parse(window.atob(cookie))
    }
    return null
  }
}
